import { MarketingDrawer } from '@app/components/general'
import { metaSetter } from '@app/utils'
import { Header, Header2, Header3 } from '@app/components/general/header'
import { SectionContainer } from '@app/components/stateless/containers/section-container'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import { Paragraph } from '@app/components/stateless/typo/paragraph'
import Trans from 'next-translate/Trans'
import loadNamespaces from 'next-translate/loadNamespaces'
import type { GetStaticProps } from 'next'
import { I18nDictionary } from 'next-translate'
import { blueLink } from '@app/components/stateless/typo/link-style'

export const getStaticProps: GetStaticProps<{
  __lang: string
  __namespaces?: Record<string, I18nDictionary>
}> = async (ctx) => {
  return {
    props: await loadNamespaces({
      ...ctx,
      pathname: '/desktop',
    }),
  }
}

function DesktopApp() {
  const { t } = useTranslation('desktop')

  return (
    <MarketingDrawer>
      <SectionContainer container block>
        <Header>{t('header')}</Header>
        <Paragraph className='py-2 font-light'>{t('beta')}</Paragraph>
        <Paragraph className='text-lg pb-5'>{t('header-d')}</Paragraph>
        <Header2>{t('web')}</Header2>
        <Paragraph className='text-base'>{t('web-d')}</Paragraph>
        <div className='py-5'>
          <Header3>{t('focus')}</Header3>
          <Trans
            i18nKey='desktop:focus-d'
            components={[
              <Paragraph key={'focus-1'} />,
              <a
                href='https://github.com/a11ywatch/a11ywatch-web-lite/tree/main/src-tauri'
                className={blueLink}
                target={'_blank'}
                rel='noreferrer'
                key={'focus-2'}
              />,
            ]}
          />
        </div>
      </SectionContainer>
    </MarketingDrawer>
  )
}

export default metaSetter(
  { DesktopApp },
  {
    translation: 'desktop',
  }
)
